module.exports = __webpack_public_path__ + "images/file_icons_v2/mpg-109c3e3ecb7a7d5b1cab33f2614a26fe.svg";